import React from 'react';
import Logo from './Logo';
import styled from 'styled-components';
import {Text, TokenTextColor} from '@volkswagen-onehub/components-core';

const CustomReferenceLabelContainer = styled.div<{color: string}>`
  width: min-content;
  display: flex;
  color: ${(props) => (props.color ? props.color : '#000')};
  column-gap: 5px;
  position: relative;
  top: -11px;
  margin-left: 8px;
  align-items: center;
`;

const LogoContainer = styled.div``;

const CustomReferenceLabel = (props: any) => {
  const {fill, value, viewBox} = props;
  return (
    <g>
      <foreignObject
        {...viewBox}
        width="100"
        height="50"
        style={{overflow: 'visible'}}
      >
        <CustomReferenceLabelContainer color={fill}>
          <LogoContainer aria-hidden="true">
            <Logo />
          </LogoContainer>
          <Text color={TokenTextColor.inherit} bold>
            {value}
          </Text>
        </CustomReferenceLabelContainer>
      </foreignObject>
    </g>
  );
};

export default CustomReferenceLabel;
